export enum RelationType {
    LoadingUnloadingLocation = 1,
    TransportVehicleStation = 2,
    CustomerLocation = 3,
    OrganizationBranchLocation = 4,
    VehicleTransferOrStorageLocation = 5,
    Customer = 6,
    Owner = 7,
    Supplier = 8,
}

export const RelationTypeOptions = [
    {value: RelationType.LoadingUnloadingLocation, label: 'core.relation_type.loading_unloading_location'},
    {value: RelationType.TransportVehicleStation, label: 'core.relation_type.transport_vehicle_station'},
    {value: RelationType.CustomerLocation, label: 'core.relation_type.customer_location'},
    {value: RelationType.OrganizationBranchLocation, label: 'core.relation_type.organization_branch_location'},
    {value: RelationType.VehicleTransferOrStorageLocation, label: 'core.relation_type.vehicle_transfer_or_storage_location'},
    {value: RelationType.Customer, label: 'core.relation_type.customer'},
    {value: RelationType.Owner, label: 'core.relation_type.owner'},
    {value: RelationType.Supplier, label: 'core.relation_type.supplier'},
]
